import { ReactNode } from 'react'
import { useLocation, Navigate } from 'react-router-dom'
import { Box, CircularProgress } from '@mui/material'
import { useOnboarding } from '../hooks/useOnboarding'

interface OnboardingGuardProps {
  children: ReactNode
}

/**
 * Redirects to /onboarding when the user has not completed onboarding.
 * Skips the check when already on /onboarding.
 */
export const OnboardingGuard = ({ children }: OnboardingGuardProps) => {
  const { pathname } = useLocation()
  const { onboardingComplete, onboardingStatusLoading } = useOnboarding()

  if (pathname === '/onboarding') {
    return <>{children}</>
  }

  if (onboardingStatusLoading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
        <CircularProgress />
      </Box>
    )
  }

  if (!onboardingComplete) {
    return <Navigate to="/onboarding" replace />
  }

  return <>{children}</>
}
